import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { abnjSso } from '../sso';

// Wraps pages that need a signed-in member. The same file works in any njjamaat.org
// React app that uses the subdomain kit (copy it as-is).
export default function ProtectedRoute() {
  const { isAuthenticated, authChecked } = useAuth();
  const mustSignIn = authChecked && !isAuthenticated;

  useEffect(() => {
    // Not signed in: go to the sign-in page. signIn() remembers this page (the
    // redirect_after_login cookie); after sign-in, this app's /callback brings the
    // user back here.
    if (mustSignIn) abnjSso.signIn();
  }, [mustSignIn]);

  // Wait for the initial session check, and render nothing while leaving to sign in.
  if (!authChecked || !isAuthenticated) return null;

  return <Outlet />;
}
